import {
  Application,
  GetCurrentUserAccountQuery,
  Account as HavelockAccount
} from '@lib/graphql/havelock/__generated__/graphql'
import { Account as ProdactiveAccount } from '@lib/graphql/prodactive/__generated__/graphql'

type CurrentAccount = GetCurrentUserAccountQuery['getCurrentUserAccount']

export type CurrentAccountViewData = CurrentAccount & {
  permissionsNames: string[]
}

export const currentAccountToViewData = (
  account: CurrentAccount
): CurrentAccountViewData => ({
  ...account,
  permissionsNames: account.permissions
    .filter((permission) => permission.application === Application.Prodactive)
    .map((permission) => permission.name)
})

export const accountToProdactiveAccount = (
  account: HavelockAccount
): ProdactiveAccount => ({
  active: account.isActive,
  datePreferences: account.datePreferences,
  email: account.email,
  fullName: account.fullName,
  havelockEnabled: account.havelockEnabled,
  id: account.id,
  isActive: account.isActive,
  jobTitle: account.jobTitle
    ? {
        active: account?.jobTitle?.isActive,
        id: account?.jobTitle?.id,
        name: account?.jobTitle?.name,
        createdAt: null,
        organizationId: null
      }
    : undefined,
  lang: account.lang,
  mobilePhone: account.mobilePhone,
  name: account.fullName,
  organization: account.organization
    ? {
        active: account.organization?.isActive,
        id: account.organization?.id,
        language: account.organization?.language,
        logo: account.organization?.logo?.presignedUrl,
        name: account.organization?.name,
        providerId: account.organization?.providerId,
        defaultCalendar: null
      }
    : undefined,
  permissions:
    account.permissions?.map((p) => ({
      application: p.application,
      name: p.name
    })) ?? [],
  prodactiveEnabled: account.prodactiveEnabled,
  profileImage: account.profileImage?.thumbnailUrl,
  timezone: account.timezone
})
